import type { ReactNode } from 'react';
import { Eyebrow, Heading, Text } from './Text.tsx';
import { Row, Spacer } from '../primitives/Row.tsx';
import { Stack } from '../primitives/Stack.tsx';

export interface PageHeaderProps {
  eyebrow: string;
  title: ReactNode;
  description?: ReactNode;
  /** Trailing controls (button, badge, toggles) pinned to the end of the header row. */
  actions?: ReactNode;
  className?: string;
}

/**
 * The one high-level header every full-page screen starts with, so pages don't
 * drift on heading level, spacing, or wrapper element (which reads as the shell
 * "jumping" between routes).
 */
export function PageHeader({ eyebrow, title, description, actions, className }: PageHeaderProps) {
  return (
    <header className={className}>
      <Row align="end" gap={4} wrap>
        <Stack gap={1}>
          <Eyebrow>{eyebrow}</Eyebrow>
          <Heading level={1}>{title}</Heading>
          {description != null && (
            <Text tone="soft" size="md">
              {description}
            </Text>
          )}
        </Stack>
        {actions != null && (
          <>
            <Spacer />
            {actions}
          </>
        )}
      </Row>
    </header>
  );
}
